module.exports = __webpack_public_path__ + "img/folder.a9a1f07c.svg";